<template>
	<ParamWrapper v-bind="wrapperProps" @input-data-closed="onDataInputMenuClose" hideTitle hideMetadata>
		<SelectTableDropdownInput
			v-on="componentListeners"
			v-bind="componentProps"
			:dataChipClass="'table-param'"
			:previousStepData="previousStepData"
			:isDropdownOpen="showDataMenu"
			ref="richEditor"
		/>
		<template #input-data>
			<ListSourceDataInputMenu :param="param" v-on="dataInputListeners" ref="data-input-menu" />
		</template>
	</ParamWrapper>
</template>

<script>
import InListParamTypeMixin from '../mixins/ListMixins/InListParamTypeMixin';
import ListSourceDataInputMenu from '../../DataInputMenus/ListDataInputMenus/ListSourceDataInputMenu';
import InListParamTypeExtenderDataInputMenuMixin from '../mixins/ListMixins/InListParamTypeExtenderDataInputMenuMixin';
import ThisFlowMixin from '../mixins/ThisFlowMixin';
import ParamsService from '../../../../../utils/ParamsService';
import { getNodeByUuidForSelectedWorkflowVersion } from '@/store/modules/selectedWorkflow/getters';
import SelectTableDropdownInput from '../../inputsComponents/SelectTableDropdownInput';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'ListSourceParamType',
	mixins: [InListParamTypeMixin, InListParamTypeExtenderDataInputMenuMixin, ThisFlowMixin],
	components: { ListSourceDataInputMenu, SelectTableDropdownInput },
	computed: {
		...mapGettersShorthand({ getNodeByUuidForSelectedWorkflowVersion }),
		componentProps() {
			const CHOOSE_TABLE_PLACEHOLDER_TEXT = 'Choose table';
			const RICH_TEXT_BOX_PROPS = {
				...this.$attrs,
				inputFieldHint: this.param.placeholder || CHOOSE_TABLE_PLACEHOLDER_TEXT,
				textAreaMode: this.isTextArea,
				value: this.localValue,
				isFocused: this.showDataMenu,
				readonly: this.readonly,
			};
			return RICH_TEXT_BOX_PROPS;
		},
		componentListeners() {
			const RICH_TEXT_BOX_LISTENERS = {
				focus: this.onInputFocus,
				blur: this.onInputBlur,
				input: (val) => (this.localValue = val),
				click: this.onInputClick,
			};
			return RICH_TEXT_BOX_LISTENERS;
		},
		previousStepData() {
			const selectedNodeUUID = ParamsService.extractNodeUUIDFromValue(this.localValue);
			return this.getNodeByUuidForSelectedWorkflowVersion(selectedNodeUUID);
		},
	},
	mounted() {
		this.setReplaceValueOnSelection(true);
		this.setDisableCustomMultipleSelectionSupport(true);
		this.$nextTick(() => {
			this.setInputElement(this.$refs['richEditor']?.$el);
		});
	},
};
</script>
<style lang="scss" scoped></style>
